const corpList = [
    {
        id: 1,
        chkID : "checkbox1",
        header: "대출 꾸러미", 
        contents:   (
            <>
                <ul className="list dot blue">
                    <li>사업자등록증명원</li>
                    <li>부가가치세과세표준증명원<br/>(또는 면세사업자수입금액증명원)</li>
                    <li className="noteMark">소득금액증명원</li>
                    <li>표준재무제표증명</li>
                    <li>납세증명서(국세)</li>
                    <li>납세증명서(지방세)</li>
                    <li>4대보험완납증명서</li>
                    <li>부가세신고서</li>
                    <li>매입매출처별세금계산서합계표</li>
                    <li className="noteMark">주민등록등본</li>
                    <li>매출정보자료<br/>(현금, 전자세금계산서)</li>
                </ul>
                <ul className="noteWrap mt16 list asterisk blue">
                    <li>개인사업자만 제출하는 서류</li>
                </ul>
            </>
                ),
    },
];

const indiList = [
    {
        id: 1,
        chkID : "checkbox1",
        header: "대출 꾸러미", 
        contents:   (
            <>
                <ul className="list dot blue">
                    <li>사업자등록증명원</li>
                    <li>부가가치세과세표준증명원<br/>(또는 면세사업자수입금액증명원)</li>
                    <li className="noteMark">소득금액증명원</li>
                    <li>표준재무제표증명</li>
                    <li>납세증명서(국세)</li>
                    <li>납세증명서(지방세)</li>
                    <li>4대보험완납증명서</li>
                    <li>부가세신고서</li>
                    <li>매입매출처별세금계산서합계표</li>
                    <li className="noteMark">주민등록등본</li>
                    <li>매출정보자료<br/>(현금, 전자세금계산서)</li>
                </ul>
                <ul className="noteWrap mt16 list asterisk blue">
                    <li>개인사업자만 제출하는 서류</li>
                </ul>
            </>
                ),
    },
];
export default (props)=> {
    switch (props) {
      case 'corpList' :    return corpList;  
      case 'indiList' :    return indiList; 
      default :            return null;
    }
};